import './Login.css';
import { connect } from 'react-redux';
import { t } from 'i18next';
import React from 'react';
import { signIn } from '../../reducer/actions';

const Login = ({ dispatch, loginError }) => {
  let user = '';
  let password = '';

  return (
    <form className="Login"
      onSubmit={(event) => {
        event.preventDefault();
        dispatch(signIn(user.value, password.value));
      }}
    >
      <label className="error">{loginError}</label>

      <label>{t('login.email')}</label>
      <input type="email"
        id="email"
        name="email"
        ref={node => user = node}
      />
      <br />

      <label>{t('login.password')}</label>
      <input type="password"
        id="password"
        name="password"
        ref={node => password = node}
      />
      <br />

      <button type="submit">{t('login.title')}</button>

    </form>
  );
};

export default connect(s => s)(Login);
